import React, { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import logger from '../../../utils/logger';

const Guest = ({ onHostsLoginClick }) => {
  const navigate = useNavigate();
  const onGuestClick = () => {
    localStorage.setItem("allowguest", "1");
    const roomId = localStorage.getItem("roomId");
    logger("log", "roomId", roomId);
    navigate(`/${roomId}`);
  };
  //   const { roomId: roomIdParam } = useParams();
  // const roomId = searchParams.get("roomId");

  return (
    <div className="w-full lg:w-1/2 px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16 h-full overflow-y-auto bg-black relative">
      <div className="max-w-md mx-auto lg:mx-0">
        <div className="flex flex-col items-start mb-6 sm:mb-8">
          <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#ffffff] mb-3 sm:mb-4">
            Join the Meeting
          </h2>
          <p className="w-full font-montserrat font-medium text-sm sm:text-base leading-6 text-white">
            Choose how you'd like to join the meeting room
          </p>
        </div>

        <div className="flex flex-col items-center gap-4 sm:gap-5">
          <button
            type="button"
            onClick={() => {
              onGuestClick();
            }}
            className="w-full max-w-sm bg-[#1CD760] rounded-full hover:bg-green-primary text-white font-semibold text-sm sm:text-base py-3 sm:py-4 transition-colors duration-200"
          >
            Continue as Guest
          </button>

          <button
            type="button"
            onClick={() => {
              onHostsLoginClick();
            }}
            className="w-full max-w-sm rounded-full border border-[#1CD760] text-[#1CD760] font-semibold text-sm sm:text-base py-3 sm:py-4 transition-colors duration-200 hover:bg-green-secondary/10"
          >
            Hosts and Speakers Login
          </button>
        </div>

        <div className="flex flex-col items-center mt-12 sm:mt-16 lg:mt-20">
          <span className="text-[#FFFFFF] opacity-60 text-xs sm:text-sm text-center px-4">
            Guests can join with limited features. Hosts and speakers get full
            access.
          </span>
        </div>

        <div className="absolute bottom-4 sm:bottom-6 lg:bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center justify-center">
          <p className="text-[#ffffff] opacity-60 text-xs text-center">
            R-Link Email Support:
            <br /> support@r-link.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default Guest;
